import { render, staticRenderFns } from "./ForumComment.vue?vue&type=template&id=3d66a155&scoped=true&"
import script from "./ForumComment.vue?vue&type=script&lang=js&"
export * from "./ForumComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d66a155",
  null
  
)

export default component.exports